var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 25,
    viewBox: "0 0 16 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_139_2458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 4C1.55313 4 2 4.44687 2 5V15.5C2 15.775 2.225 16 2.5 16H15C15.5531 16 16 16.4469 16 17C16 17.5531 15.5531 18 15 18H2.5C1.11875 18 0 16.8813 0 15.5V5C0 4.44687 0.446875 4 1 4ZM4 7C4 6.44688 4.44688 6 5 6H11C11.5531 6 12 6.44688 12 7C12 7.55312 11.5531 8 11 8H5C4.44688 8 4 7.55312 4 7ZM5 9H9C9.55313 9 10 9.44688 10 10C10 10.5531 9.55313 11 9 11H5C4.44688 11 4 10.5531 4 10C4 9.44688 4.44688 9 5 9ZM5 12H13C13.5531 12 14 12.4469 14 13C14 13.5531 13.5531 14 13 14H5C4.44688 14 4 13.5531 4 13C4 12.4469 4.44688 12 5 12Z",
    fill: "#9CA3AF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_139_2458"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 3H16V19H0V3Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.7b1af1724aedcd2c685ba1585ee0ab59.svg";
export { ForwardRef as ReactComponent };